import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "font-small" }
const _hoisted_3 = { class: "width-small" }
const _hoisted_4 = { class: "width-small" }
const _hoisted_5 = { class: "ma-4" }
const _hoisted_6 = { class: "mt-8" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex my-3"
}
const _hoisted_8 = { class: "d-flex my-4" }
const _hoisted_9 = { class: "my-12 d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_expansion_panel_header = _resolveComponent("v-expansion-panel-header")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expansion_panel_content = _resolveComponent("v-expansion-panel-content")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _ctx.isFormValid,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFormValid) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Petty Cash Book", -1)),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            to: `/cashbook/${_ctx.yearMonth}`,
            target: "_blank",
            disabled: !_ctx.yearMonth || _ctx.isLoading,
            color: "primary",
            variant: "outlined",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-tray-arrow-down", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
            ]),
            _: 1
          }, 8, ["to", "disabled"]),
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accountTitleDialog = true)),
            disabled: _ctx.isLoading,
            color: "primary",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-plus", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" Account Title ", -1))
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_component_v_card, {
          variant: "outlined",
          class: "mt-6 pa-2",
          color: "grey-lighten-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _cache[14] || (_cache[14] = _createElementVNode("h5", null, "Year", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.searchFilter.year,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilter.year) = $event)),
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "",
                          type: "number",
                          disabled: _ctx.isLoading
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Month", -1)),
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.searchFilter.month,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilter.month) = $event)),
                          items: _ctx.monthItems,
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "",
                          disabled: _ctx.isLoading
                        }, null, 8, ["modelValue", "items", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      "align-self": "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.listCashbook,
                          disabled: _ctx.isLoading,
                          color: "primary",
                          variant: "flat",
                          class: "search-button",
                          loading: _ctx.isLoading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, { class: "mx-2 mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.isFinalized,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isFinalized) = $event)),
                      items: _ctx.finalizeItems,
                      filled: "",
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, {
          class: "my-4",
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "10",
                  style: {"overflow-x":"scroll"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, {
                      "fixed-header": "",
                      style: {"min-width":"78vw"}
                    }, {
                      default: _withCtx(() => [
                        _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "No."),
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Account"),
                            _createElementVNode("th", null, "Description"),
                            _createElementVNode("th", null, "Supplier"),
                            _createElementVNode("th", null, "Income"),
                            _createElementVNode("th", null, "Expense"),
                            _createElementVNode("th", null, "Balance"),
                            _createElementVNode("th", null, "Tax"),
                            _createElementVNode("th", null, "Notes"),
                            _createElementVNode("th", null, "Delete")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("td", null, "Withdrawal", -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
                            _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, [
                              (_ctx.cashbook && _ctx.cashbook.carriedAmount != null)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: _ctx.cashbook.carriedAmount,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cashbook.carriedAmount) = $event)),
                                    type: "number",
                                    rules: [_ctx.isNotMinus],
                                    class: "font-small",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "rules"]))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                value: _ctx.cashbook ? _ctx.cashbook.carriedAmount : 0,
                                class: "font-small",
                                variant: "outlined",
                                filled: "",
                                density: "compact",
                                readonly: "",
                                "hide-details": ""
                              }, null, 8, ["value"])
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("td", null, null, -1)),
                            _cache[23] || (_cache[23] = _createElementVNode("td", null, null, -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("td", null, null, -1))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (item, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.detailId
                            }, [
                              _createElementVNode("td", _hoisted_2, _toDisplayString(i + 1), 1),
                              _createElementVNode("td", _hoisted_3, [
                                _createVNode(_component_v_select, {
                                  value: _ctx.getDayfromDate(item.date),
                                  onChange: ($event: any) => (item.date = _ctx.getDatefromDay($event)),
                                  items: _ctx.dayItems,
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  "append-icon": ""
                                }, null, 8, ["value", "onChange", "items"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_select, {
                                  value: item.title ? item.title.titleId : '',
                                  onChange: ($event: any) => (item.titleId = $event),
                                  items: _ctx.accountTitleList,
                                  "item-title": "name",
                                  "item-value": "titleId",
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  "append-icon": "",
                                  "small-chips": ""
                                }, null, 8, ["value", "onChange", "items"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  modelValue: item.description,
                                  "onUpdate:modelValue": ($event: any) => ((item.description) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  modelValue: item.supplier,
                                  "onUpdate:modelValue": ($event: any) => ((item.supplier) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  rules: [_ctx.isNotMinus],
                                  type: "number",
                                  modelValue: item.incomeAmount,
                                  "onUpdate:modelValue": ($event: any) => ((item.incomeAmount) = $event)
                                }, null, 8, ["rules", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  type: "number",
                                  rules: [_ctx.isNotMinus],
                                  modelValue: item.outgoAmount,
                                  "onUpdate:modelValue": ($event: any) => ((item.outgoAmount) = $event)
                                }, null, 8, ["rules", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  filled: "",
                                  "hide-details": "",
                                  density: "compact",
                                  readonly: "",
                                  value: item.incomeAmount - item.outgoAmount
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("td", _hoisted_4, [
                                _createVNode(_component_v_select, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  chips: "",
                                  "small-chips": "",
                                  "append-icon": "",
                                  items: _ctx.taxationOptions,
                                  "item-title": "text",
                                  "item-value": "value",
                                  modelValue: item.taxation,
                                  "onUpdate:modelValue": ($event: any) => ((item.taxation) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "font-small",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  modelValue: item.note,
                                  "onUpdate:modelValue": ($event: any) => ((item.note) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (
                          _ctx.deleteRow({
                            detailId: item.detailId,
                          })
                        ),
                                  small: "",
                                  dark: "",
                                  color: "grey",
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("tr", null, [
                            _cache[25] || (_cache[25] = _createElementVNode("td", null, "Total", -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("td", null, null, -1)),
                            _cache[27] || (_cache[27] = _createElementVNode("td", null, null, -1)),
                            _cache[28] || (_cache[28] = _createElementVNode("td", null, null, -1)),
                            _cache[29] || (_cache[29] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                value: _ctx.cashbook ? _ctx.cashbook.totalIncomeAmount : 0,
                                class: "font-small",
                                variant: "outlined",
                                filled: "",
                                density: "compact",
                                readonly: "",
                                "hide-details": ""
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                value: _ctx.cashbook ? _ctx.cashbook.totalOutgoAmount : 0,
                                class: "font-small",
                                variant: "outlined",
                                filled: "",
                                density: "compact",
                                readonly: "",
                                "hide-details": ""
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                value: _ctx.cashbook ? _ctx.cashbook.remainingAmount : 0,
                                class: "font-small",
                                variant: "outlined",
                                filled: "",
                                density: "compact",
                                readonly: "",
                                "hide-details": ""
                              }, null, 8, ["value"])
                            ]),
                            _cache[30] || (_cache[30] = _createElementVNode("td", null, null, -1)),
                            _cache[31] || (_cache[31] = _createElementVNode("td", null, null, -1)),
                            _cache[32] || (_cache[32] = _createElementVNode("td", null, null, -1))
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.addDetailRow,
                        color: "primary",
                        variant: "outlined",
                        small: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                              _createTextVNode("mdi-plus", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  style: {"overflow-x":"scroll"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, {
                      "fixed-header": "",
                      density: "compact",
                      style: {"min-width":"15vw"}
                    }, {
                      default: _withCtx(() => [
                        _cache[35] || (_cache[35] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Account"),
                            _createElementVNode("th", null, "Income Total"),
                            _createElementVNode("th", null, "Expense Total"),
                            _createElementVNode("th")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountTitleList, (item, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(item.name), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getIncomebyAccountTitle(item.titleId)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getOutgobyAccountTitle(item.titleId)), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.deleteAccountTitle(item.titleId)),
                                  color: "error",
                                  "x-small": "",
                                  variant: "outlined"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.cashbook && _ctx.cashbook.attachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_v_expansion_panels, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_header, null, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode(" Attachment List ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel_content, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashbook.attachments, (item, i) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: i,
                            class: "ma-1",
                            variant: "outlined"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, { class: "pa-5 d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { start: "" }, {
                                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                      _createTextVNode("mdi-file-document-outline", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(item.filename) + " ", 1),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    href: item.attachmentUrl,
                                    target: "_blank",
                                    color: "primary",
                                    icon: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                          _createTextVNode("mdi-tray-arrow-down", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["href"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_file_input, {
          modelValue: _ctx.file,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.file) = $event)),
          disabled: _ctx.isLoading,
          variant: "outlined",
          density: "compact",
          placeholder: "Select a file",
          onChange: _ctx.addAttachmentFile
        }, null, 8, ["modelValue", "disabled", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.clickSave,
        disabled: _ctx.cashbook == null || _ctx.isLoading || !_ctx.isFormValid,
        color: "primary",
        class: "mx-4",
        variant: "flat",
        large: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.accountTitleDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountTitleDialog) = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createTextVNode("Account Title", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                            _createTextVNode(" Account Name ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.accountTitleName,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountTitleName) = $event)),
                              variant: "outlined",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.accountTitleDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.createAccountTitle,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}